<script>
import useConfiguration from "@/use/Configuration";
import {onMounted} from "vue";
import {useSecurityStore} from "@/stores/Security";
import useSharedMethod from "@/use/SharedMethod";
import useSharedSelectData from "@/use/SharedSelectData";
import useSharedData from "@/use/SharedData";

export default {
    setup() {
        const {backgroundColor} = useSharedData();
        const {evaluationPeriods, evaluationFileDisplayModes} = useSharedSelectData();
        const {loading, configurations, findAll, save} = useConfiguration();
        const {copyToClipboard} = useSharedMethod();

        const securityStore = useSecurityStore();


        onMounted(() => findAll());

        return {
            securityStore,
            evaluationPeriods,
            evaluationFileDisplayModes,
            loading,
            backgroundColor,
            configurations,
            copyToClipboard,
            save,
        }
    }
}
</script>

<template>
    <w-app :title="$t('module.configuration')">
        <template #rightToolbar>
            <w-btn-apply
                :show="securityStore.authorities['UPDATE_EVALUATION_PARAM']"
                :loading="loading"
                @press="save"
            />
        </template>

        <template #content>
            <v-tabs
                dense
                height="35"
                color="teal"
                :background-color="backgroundColor"
            >
                <v-tab>{{ $t('common.general') }}</v-tab>
                <v-tab>{{ $t('common.email') }}</v-tab>

                <v-tab-item>
                    <v-container fluid>
                        <w-fieldset title="Evaluation Compétence">
                            <v-row dense>
                                <v-col cols="4">
                                    <v-radio-group
                                        v-model="configurations[141].booll"
                                        :label="$t('common.note')"
                                        row
                                        hide-details
                                    >
                                        <v-radio :label="$t('common.percent')" :value="true"></v-radio>
                                        <v-radio :label="$t('common.digit')" :value="false"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4">
                                    <v-radio-group
                                        v-model="configurations[137].booll"
                                        :label="$t('common.note')"
                                        row
                                        hide-details
                                    >
                                        <v-radio :label="$t('evaluation.pre-selected')" :value="true"></v-radio>
                                        <v-radio :label="$t('evaluation.to_enter')" :value="false"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4"></v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[138].booll"
                                        :label="$t('evaluation.enable_target')"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[139].booll"
                                        :label="$t('evaluation.enable_sections_gravity')"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[140].booll"
                                        :label="$t('evaluation.enable_criteria_gravity')"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                        </w-fieldset>
                        <br/>
                        <w-fieldset title="Evaluation Performance">
                            <v-row dense>
                                <v-col cols="4">
                                    <w-label :label="$t('evaluation.pay_gateway')" required/>
                                    <text-field-pay-section
                                        v-model="configurations[135].strr"
                                        not-clearable
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <w-label :label="$t('evaluation.last_state')" required/>
                                    <str-evaluation-phase-autocomplete
                                        v-model="configurations[136].longg"
                                        type="EVALUATION_PERFORMANCE"
                                        not-clearable
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <w-label :label="$t('evaluation.file_display_mode')" required/>
                                    <w-dual-list-autocomplete
                                        v-model="configurations[171].stringList"
                                        :items="evaluationFileDisplayModes"
                                        multiple
                                    />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="4">
                                    <w-label :label="'Section Individuel par défaut'" required/>
                                    <w-data-select-autocomplete
                                        v-model="configurations[172].longg"
                                        type="EVALUATION_PERFORMANCE_CRITERION_CATEGORY"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <w-label :label="'Section Commun par défaut'" required/>
                                    <w-data-select-autocomplete
                                        v-model="configurations[173].longg"
                                        type="EVALUATION_PERFORMANCE_CRITERION_CATEGORY"
                                    />
                                </v-col>
                                <v-col cols="4">

                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="4">
                                    <v-radio-group
                                        v-model="configurations[146].booll"
                                        :label="$t('common.note')"
                                        row
                                        hide-details
                                    >
                                        <v-radio :label="$t('common.percent')" :value="true"></v-radio>
                                        <v-radio :label="$t('common.digit')" :value="false"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4">
                                    <v-radio-group
                                        v-model="configurations[142].booll"
                                        :label="$t('common.note')"
                                        row
                                        hide-details
                                    >
                                        <v-radio :label="$t('evaluation.pre-selected')" :value="true"></v-radio>
                                        <v-radio :label="$t('evaluation.to_enter')" :value="false"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4"></v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[143].booll"
                                        :label="$t('evaluation.enable_target')"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[144].booll"
                                        :label="$t('evaluation.enable_sections_gravity')"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[145].booll"
                                        :label="$t('evaluation.enable_criteria_gravity')"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[174].booll"
                                        :label="'Activer section commun'"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[175].booll"
                                        :label="'Activer passage globale entre les étapes'"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[176].booll"
                                        :label="'Activer passerèlle paie'"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                        </w-fieldset>
                        <br/>
                        <w-fieldset title="Demande Recrutement">
                            <v-row dense>
                                <v-col cols="4">
                                    <strong>{{ $t('evaluation.default_evaluation_recruitment_file') }}</strong>
                                    <str-evaluation-file-autocomplete
                                        v-model="configurations[115].longg"
                                        type="EVALUATION_RECRUITMENT"
                                        use-local-cache
                                        not-clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="4">
                                    <v-radio-group
                                        v-model="configurations[151].booll"
                                        :label="$t('common.note')"
                                        row
                                        hide-details
                                    >
                                        <v-radio :label="$t('common.percent')" :value="true"></v-radio>
                                        <v-radio :label="$t('common.digit')" :value="false"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4">
                                    <v-radio-group
                                        v-model="configurations[147].booll"
                                        :label="$t('common.note')"
                                        row
                                        hide-details
                                    >
                                        <v-radio :label="$t('evaluation.pre-selected')" :value="true"></v-radio>
                                        <v-radio :label="$t('evaluation.to_enter')" :value="false"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4"></v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[148].booll"
                                        :label="$t('evaluation.enable_target')"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[149].booll"
                                        :label="$t('evaluation.enable_sections_gravity')"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[150].booll"
                                        :label="$t('evaluation.enable_criteria_gravity')"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                        </w-fieldset>
                        <br/>
                        <w-fieldset title="Formation - Evaluation Chaud">
                            <v-row dense>
                                <v-col cols="4">
                                    <strong>{{ $t('evaluation.default_evaluation_training_hot_file') }}</strong>
                                    <str-evaluation-file-autocomplete
                                        v-model="configurations[132].longg"
                                        type="EVALUATION_TRAINING_HOT"
                                        use-local-cache
                                        not-clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="4">
                                    <v-radio-group
                                        v-model="configurations[156].booll"
                                        :label="$t('common.note')"
                                        row
                                        hide-details
                                    >
                                        <v-radio :label="$t('common.percent')" :value="true"></v-radio>
                                        <v-radio :label="$t('common.digit')" :value="false"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4">
                                    <v-radio-group
                                        v-model="configurations[152].booll"
                                        :label="$t('common.note')"
                                        row
                                        hide-details
                                    >
                                        <v-radio :label="$t('evaluation.pre-selected')" :value="true"></v-radio>
                                        <v-radio :label="$t('evaluation.to_enter')" :value="false"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4"></v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[153].booll"
                                        :label="$t('evaluation.enable_target')"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[154].booll"
                                        :label="$t('evaluation.enable_sections_gravity')"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[155].booll"
                                        :label="$t('evaluation.enable_criteria_gravity')"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                        </w-fieldset>
                        <br/>
                        <w-fieldset title="Formation - Evaluation Froid">
                            <v-row dense>
                                <v-col cols="4">
                                    <strong>{{ $t('evaluation.default_evaluation_training_cold_file') }}</strong>
                                    <str-evaluation-file-autocomplete
                                        v-model="configurations[133].longg"
                                        type="EVALUATION_TRAINING_COLD"
                                        use-local-cache
                                        not-clearable
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <w-label :label="$t('training.cold_evaluation_delay')"/>
                                    <w-text-field
                                        v-model="configurations[106].longg"
                                        :suffix="$t('common.DAILY')"
                                        not-clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="4">
                                    <v-radio-group
                                        v-model="configurations[161].booll"
                                        :label="$t('common.note')"
                                        row
                                        hide-details
                                    >
                                        <v-radio :label="$t('common.percent')" :value="true"></v-radio>
                                        <v-radio :label="$t('common.digit')" :value="false"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4">
                                    <v-radio-group
                                        v-model="configurations[157].booll"
                                        :label="$t('common.note')"
                                        row
                                        hide-details
                                    >
                                        <v-radio :label="$t('evaluation.pre-selected')" :value="true"></v-radio>
                                        <v-radio :label="$t('evaluation.to_enter')" :value="false"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4"></v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[158].booll"
                                        :label="$t('evaluation.enable_target')"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[159].booll"
                                        :label="$t('evaluation.enable_sections_gravity')"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="configurations[160].booll"
                                        :label="$t('evaluation.enable_criteria_gravity')"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                        </w-fieldset>
                    </v-container>
                </v-tab-item>
                <!--<v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="6">
                                <w-label :label="$t('common.email_object')"/>
                                <w-text-field
                                    v-model="configurations[102].strr"
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6">
                                <w-label :label="$t('common.email_body')"/>
                                <w-simple-text-area
                                    v-model="configurations[103].strr"
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>-->
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="6">
                                <strong>{{ $t('common.email_object') }}</strong>
                                <w-text-field
                                    v-model="configurations[109].strr"
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6">
                                <strong>{{ $t('common.email_body') }}</strong>
                                <w-simple-text-area
                                    v-model="configurations[110].strr"
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
            </v-tabs>
        </template>
    </w-app>
</template>